import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { Axios } from "../../../Api/axios";
import { ALLSTD, ADMIN_ALL_CLASSES, baseURL } from "../../../Api/Api";
import { useCounts } from "../../../context/CountsContext";
import DashSelect from "../../../Components/Dashboard/DashSelect";
import "../dash-cards.css";

const DELETE_STD = (id) => `/admin/student/${id}`;

function StudentCard({ student, onDeleteRequest, deleting, onRenew, renewing }) {
  const photoUrl = student.photo
    ? `${baseURL}/uploads/students/${student.photo}`
    : null;

  const className    = student.Class?.name || student.class?.name || null;
  const subjectCount = student.subjects?.length ?? 0;
  const isSubjectBased = subjectCount > 0;

  return (
    <div className="dc-card">
      <div className="dc-card-cap" />
      <div className="dc-card-avatar">
        {photoUrl ? (
          <img src={photoUrl} alt={student.name} />
        ) : (
          <div className="dc-card-avatar-placeholder dc-avatar-green">
            <svg width="30" height="30" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
            </svg>
          </div>
        )}
      </div>

      <div className="dc-card-body">
        <h3 className="dc-card-name">{student.name}</h3>

        {student.phone && (
          <p className="dc-card-meta" style={{ direction: "ltr" }}>
            <svg width="12" height="12" fill="currentColor" viewBox="0 0 24 24">
              <path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.46.57 3.58a1 1 0 0 1-.25 1.01l-2.2 2.2z" />
            </svg>
            {student.phone}
          </p>
        )}

        {student.year && (
          <p className="dc-card-meta dc-card-meta-green">
            <svg width="12" height="12" fill="currentColor" viewBox="0 0 24 24">
              <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
            </svg>
            {student.year}
          </p>
        )}

        {className && (
          <p className="dc-card-meta dc-meta-class">
            <svg width="12" height="12" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
            </svg>
            {className}
          </p>
        )}

        <p className={`dc-card-meta ${isSubjectBased ? "dc-meta-subject" : "dc-meta-classsys"}`}>
          {isSubjectBased ? (
            <>
              <svg width="11" height="11" fill="currentColor" viewBox="0 0 24 24">
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 15.82 9.64 15 12 15s4.53.82 6.24 2.19c.48.38.76.97.76 1.58V19z" />
              </svg>
              نظام مواد · {subjectCount}
            </>
          ) : (
            <>
              <svg width="11" height="11" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
              </svg>
              نظام صفي
            </>
          )}
        </p>
      </div>

      <div style={{ padding: "0 14px 10px", display: "flex", justifyContent: "center" }}>
        <button
          onClick={() => onRenew(student)}
          disabled={renewing}
          style={{ width: "100%", padding: "7px 0", borderRadius: 8, border: "1.5px solid #00a74f", background: renewing ? "#f0fdf4" : "#fff", color: "#00a74f", fontWeight: 700, fontSize: "0.82rem", cursor: renewing ? "not-allowed" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}
        >
          🔄 {renewing ? "جاري التجديد..." : "تجديد الكود"}
        </button>
      </div>

      <div className="dc-card-actions">
        <Link to={`/dashboard/users/${student.id}`} className="dc-action-btn dc-edit-btn">
          <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24">
            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
          </svg>
          تعديل
        </Link>
        <button className="dc-action-btn dc-delete-btn" onClick={() => onDeleteRequest(student)} disabled={deleting}>
          <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24">
            <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
          </svg>
          {deleting ? "..." : "حذف"}
        </button>
      </div>
    </div>
  );
}

function SkeletonCard() {
  return (
    <div className="dc-card dc-skeleton">
      <div className="dc-card-cap" />
      <div className="dc-card-avatar" />
      <div className="dc-card-body" style={{ paddingBottom: 14 }}>
        <div className="dc-sk-line dc-sk-lg" />
        <div className="dc-sk-line dc-sk-sm" />
        <div className="dc-sk-line dc-sk-sm" />
        <div className="dc-sk-line dc-sk-sm" />
      </div>
      <div className="dc-sk-actions">
        <div className="dc-sk-btn" style={{ borderBottomRightRadius: 18 }} />
        <div className="dc-sk-btn" style={{ borderBottomLeftRadius: 18 }} />
      </div>
    </div>
  );
}

export default function Users() {
  const [users, setUsers]       = useState([]);
  const [loading, setLoading]   = useState(true);
  const [classes, setClasses]   = useState([]);
  const [years, setYears]       = useState([]);
  const [filterClass, setFilterClass] = useState("");
  const [filterYear,  setFilterYear]  = useState("");
  const [pendingDelete, setPendingDelete] = useState(null);
  const [deleting, setDeleting]           = useState(false);
  const [renewedCode, setRenewedCode]     = useState(null); // { name, expiresAt }
  const [renewingId, setRenewingId]       = useState(null);
  const { refreshCounts } = useCounts();

  // fetch classes for dropdown once
  useEffect(() => {
    Axios.get(ADMIN_ALL_CLASSES)
      .then((res) => setClasses(res.data.classes || res.data || []))
      .catch(() => {});
  }, []);

  const fetchStudents = useCallback((classId, year) => {
    setLoading(true);
    const params = new URLSearchParams({ page: 1, limit: 200 });
    if (classId) params.set("classId", classId);
    if (year)    params.set("year",    year);

    Axios.get(`${ALLSTD}?${params.toString()}`)
      .then((res) => {
        const list = res.data.students || [];
        setUsers(list);
        // collect unique years from full unfiltered fetch for the dropdown
        if (!classId && !year) {
          const unique = [...new Set(list.map((s) => s.year).filter(Boolean))].sort();
          setYears(unique);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, []);

  // refetch whenever filters change
  useEffect(() => {
    fetchStudents(filterClass, filterYear);
  }, [filterClass, filterYear, fetchStudents]);

  async function handleRenew(student) {
    setRenewingId(student.id);
    try {
      const res = await Axios.put(`/admin/renew_student/${student.id}`);
      setRenewedCode({ name: student.name, code: res.data.code, expiresAt: res.data["ينتهي_في"] });
    } catch (err) {
      console.error(err);
    } finally {
      setRenewingId(null);
    }
  }

  async function handleDelete() {
    if (!pendingDelete) return;
    setDeleting(true);
    try {
      await Axios.delete(DELETE_STD(pendingDelete.id));
      setUsers((prev) => prev.filter((s) => s.id !== pendingDelete.id));
      setPendingDelete(null);
      refreshCounts();
    } catch {
    } finally {
      setDeleting(false);
    }
  }

  function clearFilters() {
    setFilterClass("");
    setFilterYear("");
  }

  const hasFilters = filterClass || filterYear;

  return (
    <div className="dash-page">
      {renewedCode && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, backdropFilter: "blur(2px)" }} onClick={() => setRenewedCode(null)}>
          <div style={{ background: "#fff", borderRadius: "20px", padding: "36px 32px", maxWidth: "380px", width: "90%", textAlign: "center", direction: "rtl", boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }} onClick={(e) => e.stopPropagation()}>
            <div style={{ width: 64, height: 64, borderRadius: "50%", background: "#f0fdf4", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px" }}>
              <svg width="30" height="30" fill="#00a74f" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg>
            </div>
            <h3 style={{ fontWeight: 700, color: "#00a74f", marginBottom: 8 }}>تم تجديد الاشتراك</h3>
            <p style={{ color: "#6b7280", fontSize: "0.92rem", marginBottom: 20 }}>
              تم تمديد اشتراك الطالب <strong style={{ color: "#111" }}>{renewedCode.name}</strong>
            </p>
            <div style={{ background: "#f0fdf4", border: "1.5px solid #bbf7d0", borderRadius: "12px", padding: "16px 20px", marginBottom: 24 }}>
              <p style={{ margin: 0, fontSize: "0.82rem", color: "#6b7280", marginBottom: 4 }}>الاشتراك صالح حتى</p>
              <span style={{ fontSize: "1.2rem", fontWeight: 700, color: "#00a74f" }}>{renewedCode.expiresAt}</span>
            </div>
            <button onClick={() => setRenewedCode(null)} style={{ width: "100%", padding: "11px 0", borderRadius: 12, border: "none", background: "linear-gradient(135deg,#00a74f,#007a38)", color: "#fff", fontWeight: 700, fontSize: "0.95rem", cursor: "pointer" }}>
              حسناً، تم
            </button>
          </div>
        </div>
      )}

      {pendingDelete && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, backdropFilter: "blur(2px)" }} onClick={() => !deleting && setPendingDelete(null)}>
          <div style={{ background: "#fff", borderRadius: "20px", padding: "36px 32px", maxWidth: "400px", width: "90%", textAlign: "center", direction: "rtl", boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }} onClick={(e) => e.stopPropagation()}>
            <div style={{ width: 64, height: 64, borderRadius: "50%", background: "#fef2f2", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
              <svg width="30" height="30" fill="#dc2626" viewBox="0 0 24 24">
                <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
              </svg>
            </div>
            <h3 style={{ fontWeight: 700, fontSize: "1.2rem", marginBottom: 10, color: "#111" }}>حذف الطالب</h3>
            <p style={{ color: "#6b7280", fontSize: "0.93rem", marginBottom: 6, lineHeight: 1.6 }}>
              هل أنت متأكد من حذف الطالب <strong style={{ color: "#111" }}>"{pendingDelete.name}"</strong>؟
            </p>
            <p style={{ color: "#ef4444", fontSize: "0.82rem", marginBottom: 28 }}>لا يمكن التراجع عن هذا الإجراء.</p>
            <div style={{ display: "flex", gap: 12 }}>
              <button onClick={() => setPendingDelete(null)} disabled={deleting} style={{ flex: 1, padding: "11px 0", borderRadius: 12, border: "1.5px solid #e5e7eb", background: "#fff", fontWeight: 600, fontSize: "0.95rem", cursor: "pointer", color: "#374151" }}>
                إلغاء
              </button>
              <button onClick={handleDelete} disabled={deleting} style={{ flex: 1, padding: "11px 0", borderRadius: 12, border: "none", background: "linear-gradient(135deg,#dc2626,#b91c1c)", color: "#fff", fontWeight: 700, fontSize: "0.95rem", cursor: "pointer", opacity: deleting ? 0.7 : 1 }}>
                {deleting ? "جاري الحذف..." : "نعم، احذف"}
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="dash-page-header">
        <h1 className="dash-page-title">الطلاب</h1>
        <Link className="dash-add-btn" to="/dashboard/user/add">
          <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
          </svg>
          إضافة طالب جديد
        </Link>
      </div>

      {/* ── Filter Bar ── */}
      <div className="stu-filter-bar">
        <DashSelect
          value={filterClass}
          onChange={setFilterClass}
          options={[
            { value: "", label: "جميع الصفوف" },
            ...classes.map((c) => ({ value: c.id, label: c.name })),
          ]}
          icon={
            <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
            </svg>
          }
        />

        <DashSelect
          value={filterYear}
          onChange={setFilterYear}
          options={[
            { value: "", label: "جميع السنوات" },
            ...years.map((y) => ({ value: y, label: y })),
          ]}
          icon={
            <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24">
              <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
            </svg>
          }
        />

        {hasFilters && (
          <button className="stu-filter-clear" onClick={clearFilters}>
            <svg width="13" height="13" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
            مسح الفلتر
          </button>
        )}

        <span className="stu-filter-count">
          {loading ? "..." : `${users.length} طالب`}
        </span>
      </div>

      <div className="card-grid">
        {loading ? (
          Array.from({ length: 6 }).map((_, i) => <SkeletonCard key={i} />)
        ) : users.length === 0 ? (
          <div className="dc-empty">
            <svg width="56" height="56" fill="currentColor" viewBox="0 0 24 24">
              <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
            </svg>
            <p>{hasFilters ? "لا يوجد طلاب بهذه المعايير" : "لا يوجد طلاب بعد"}</p>
            <small>{hasFilters ? "جرّب تغيير الفلتر" : "ابدأ بإضافة طالب جديد"}</small>
          </div>
        ) : (
          users.map((student) => (
            <StudentCard key={student.id} student={student} onDeleteRequest={setPendingDelete} deleting={deleting && pendingDelete?.id === student.id} onRenew={handleRenew} renewing={renewingId === student.id} />
          ))
        )}
      </div>
    </div>
  );
}
